import {
  getAppShortName,
  getAppName,
  getAppDescription,
  getAppThemeColor,
  getAppBackgroundColor,
  BRAND_ASSET,
  getBrandAssetUrl,
} from "./config/chains";

const manifest = {
  short_name: getAppShortName(),
  name: getAppName(),
  description: getAppDescription(),
  orientation: "portrait",
  icons: [
    {
      src: getBrandAssetUrl(BRAND_ASSET.faviconSvg),
      type: "image/svg+xml",
      sizes: "512x512",
    },
    {
      src: getBrandAssetUrl(BRAND_ASSET.favicon),
      type: "image/png",
      sizes: "512x512",
      purpose: "any",
    },
    {
      src: getBrandAssetUrl(BRAND_ASSET.favicon196),
      type: "image/png",
      sizes: "196x196",
      purpose: "maskable",
    },
    {
      src: getBrandAssetUrl(BRAND_ASSET.favicon192),
      type: "image/png",
      sizes: "192x192",
    },
  ],
  start_url: "./",
  scope: ".",
  display: "standalone",
  theme_color: getAppThemeColor(),
  background_color: getAppBackgroundColor(),
  launch_handler: {
    client_mode: ["focus-existing", "auto"],
  },
  handle_links: "preferred",
  display_override: ["window-controls-overlay"],
  categories: ["finance", "business", "productivity"],
  dir: "auto",
  screenshots: [
    {
      src: "public/assets/screenshots/1280x800.png",
      sizes: "1280x800",
      type: "image/png",
    },
    {
      src: "public/assets/screenshots/750x1334.png",
      sizes: "750x1334",
      type: "image/png",
    },
  ],
};

export default manifest;
